<div class="wrap-break-word px-4 py-2 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 items-baseline text-xs text-gray-400"
     title="Börsenpreis (Spotmarkt) ohne Netzkosten, Abgaben und Aufschläge">
  <div class="grid grid-cols-[1fr_auto] gap-2 items-baseline">
    <span>Börsenpreis (¼ Stunde):</span>
    <span class="text-right">
      {{ marketPriceCt() != null ? (marketPriceCt()! | number:'1.2-2':'de') : '–' }}<span class="pl-2">ct/kWh</span>
    </span>
  </div>
  <div class="grid grid-cols-[1fr_auto] gap-2 items-baseline">
    <span>Börsenpreis (1 Stunde):</span>
    <span class="text-right">
      {{ marketPriceHourlyCt() != null ? (marketPriceHourlyCt()! | number:'1.2-2':'de') : '–' }}<span class="pl-2">ct/kWh</span>
    </span>
  </div>
</div>
